<template>
  <nav class="fixed top-0 left-0 w-full z-[1000] py-2 sm:py-3 glass-effect">
    <div class="max-w-7xl mx-auto flex justify-between items-center px-4 md:px-8">
      <div class="h-10 md:h-14">
        <router-link to="/">
          <img src="/images/logo.png" alt="Pixelab Logo" class="h-full" />
        </router-link>
      </div>

      <!-- 移动端菜单按钮 -->
      <button
        class="md:hidden text-white/80 hover:text-primary transition-all duration-300"
        @click="toggleMenu"
      >
        <i :class="['fas', isMenuOpen ? 'fa-times' : 'fa-bars', 'text-2xl']"></i>
      </button>

      <!-- 桌面端导航 -->
      <div class="hidden md:flex gap-8">
        <router-link to="/" class="nav-link" @click="scrollToSection('games')">
          <i class="fas fa-gamepad text-lg"></i>
          <span>Games</span>
        </router-link>
        <router-link to="/" class="nav-link" @click="scrollToSection('services')">
          <i class="fas fa-rocket text-lg"></i>
          <span>Services</span>
        </router-link>
        <router-link to="/" class="nav-link" @click="scrollToSection('about')">
          <i class="fas fa-star text-lg"></i>
          <span>About</span>
        </router-link>
        <router-link to="/" class="nav-link" @click="scrollToSection('contact')">
          <i class="fas fa-envelope text-lg"></i>
          <span>Contact</span>
        </router-link>
      </div>

      <!-- 移动端菜单 -->
      <div
        :class="[
          'md:hidden fixed inset-0 bg-[#0f0e1e] transition-all duration-500',
          isMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible',
        ]"
        style="top: 3.5rem"
      >
        <div class="flex flex-col items-center pt-12 gap-4 bg-[#0f0e1e] h-full px-4">
          <router-link
            to="/"
            class="nav-link-mobile bg-[#1a1830]"
            @click="handleMobileNavClick('games')"
          >
            <i class="fas fa-gamepad text-2xl"></i>
            <span class="text-lg font-medium">Games</span>
          </router-link>
          <router-link
            to="/"
            class="nav-link-mobile bg-[#1a1830]"
            @click="handleMobileNavClick('services')"
          >
            <i class="fas fa-rocket text-2xl"></i>
            <span class="text-lg font-medium">Services</span>
          </router-link>
          <router-link
            to="/"
            class="nav-link-mobile bg-[#1a1830]"
            @click="handleMobileNavClick('about')"
          >
            <i class="fas fa-star text-2xl"></i>
            <span class="text-lg font-medium">About</span>
          </router-link>
          <router-link
            to="/"
            class="nav-link-mobile bg-[#1a1830]"
            @click="handleMobileNavClick('contact')"
          >
            <i class="fas fa-envelope text-2xl"></i>
            <span class="text-lg font-medium">Contact</span>
          </router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref } from 'vue'

const isMenuOpen = ref(false)

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
  if (isMenuOpen.value) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = ''
  }
}

const handleMobileNavClick = (sectionId) => {
  toggleMenu()
  scrollToSection(sectionId)
}

const scrollToSection = (sectionId) => {
  // 如果已经在首页，直接滚动
  if (window.location.pathname === '/') {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }
  // 如果不在首页，先导航到首页，然后等待 DOM 更新后滚动
  else {
    setTimeout(() => {
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }, 100)
  }
}
</script>

<style scoped>
.glass-effect {
  @apply bg-[#0f0e1e]/80 backdrop-blur-md border-b border-primary/20;
}

.nav-link {
  @apply flex items-center gap-2 text-white/80 hover:text-primary transition-all duration-300;
}

.nav-link i {
  @apply w-5 h-5 flex items-center justify-center;
  transition: transform 0.3s ease;
}

.nav-link:hover i {
  transform: scale(1.1);
}

.nav-link-mobile {
  @apply flex flex-col items-center gap-3 text-white/90 transition-all duration-300 w-full py-6 px-6;
  @apply rounded-xl border border-white/10 active:bg-[#2a2844] active:scale-[0.98];
  @apply shadow-lg shadow-primary/5;
}

.nav-link-mobile i {
  @apply w-12 h-12 flex items-center justify-center;
  transition: transform 0.3s ease;
}

.nav-link-mobile:active i {
  transform: scale(1.1);
}
</style>
